// Generated by tools/generate-creator-packages.mjs.
// Generated from tools/contracts/creator-packages.cts. Do not edit directly.










// Runtime-neutral creator quotations. These describe rights to customer-produced content.
const PACKAGE_KINDS = ["ecommerce", "endorsement", "film"];
const PACKAGE_USES = ["advertising", "short_video_sales", "livestream_playback", "endorsement", "film"];
function normalizeCreatorPackages(input         )                   {
  if (input === undefined) return [];
  if (!Array.isArray(input) || input.length > 6) throw new Error("最多填写6个合作套餐");
  const ids = new Set        ();
  return (input                    ).map(item => {
    if (!item || typeof item !== "object" || Array.isArray(item)) throw new Error("套餐资料格式无效");
    const allowed = ["id", "name", "kind", "durationDays", "quantity", "priceFen", "uses", "schedule", "producer", "reviewer"];
    if (Object.keys(item).some(key => !allowed.includes(key))) throw new Error("套餐包含不支持的字段");
    if (typeof item.id !== "string" || !/^[a-zA-Z0-9_-]{8,64}$/.test(item.id) || ids.has(item.id)) throw new Error("套餐编号无效或重复");
    ids.add(item.id);
    const name = typeof item.name === "string" ? item.name.trim() : "";
    const schedule = item.schedule === undefined ? "" : item.schedule;
    if (!name || name.length > 40 || /[\x00-\x1f\x7f]/.test(name) || !PACKAGE_KINDS.includes(item.kind)
      || !Number.isSafeInteger(item.durationDays) || item.durationDays < 1 || item.durationDays > 3660
      || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 10000
      || !Number.isSafeInteger(item.priceFen) || item.priceFen < 1 || item.priceFen > 100000000
      || typeof schedule !== "string" || schedule.length > 100 || /[\x00-\x1f\x7f]/.test(schedule)) {
      throw new Error("请填写套餐名称、有效期限、数量和总价");
    }
    const permitted = item.kind === "film" ? ["film"] : item.kind === "ecommerce"
      ? ["advertising", "short_video_sales", "livestream_playback"]
      : ["advertising", "short_video_sales", "livestream_playback", "endorsement"];
    if (!Array.isArray(item.uses) || !item.uses.length || item.uses.length > permitted.length
      || new Set(item.uses).size !== item.uses.length || item.uses.some(use => !permitted.includes(use))
      || (item.kind === "endorsement" && !item.uses.includes("endorsement"))) throw new Error("请选择套餐对应的使用方式");
    if ((item.producer !== undefined && item.producer !== "customer") || (item.reviewer !== undefined && item.reviewer !== "creator")) throw new Error("客户制作，创作者审核");
    return { id: item.id, name, kind: item.kind, durationDays: item.durationDays, quantity: item.quantity,
      priceFen: item.priceFen, uses: PACKAGE_USES.filter(use => item.uses.includes(use)), schedule: schedule.trim(),
      producer: "customer", reviewer: "creator" };
  });
}
function packageUses(item         ) {
  const pack = normalizeCreatorPackages([item])[0];
  const labels                         = { advertising: "种草／广告短视频", short_video_sales: "短视频带货", livestream_playback: "直播间播放", endorsement: "品牌代言", film: "影视作品" };
  return pack.uses.map(use => labels[use]).join("、");
}
function packageSummary(item         ) {
  const pack = normalizeCreatorPackages([item])[0];
  const label = pack.kind === "film" ? "影视" : pack.kind === "endorsement" ? "品牌代言＋电商" : "电商";
  return `${label} · ${pack.durationDays}天 · ${pack.kind === "film" ? `${pack.quantity}部作品` : `授权客户制作${pack.quantity}条短视频`} · ¥${(pack.priceFen / 100).toFixed(2)}`;
}
function creatorPackageMinimumPriceFen(item                                           ) {
  return item.kind === "film" ? 50000 * item.quantity : 50000;
}
export { PACKAGE_KINDS, PACKAGE_USES, normalizeCreatorPackages, packageSummary, packageUses, creatorPackageMinimumPriceFen };
